import { HSDetails } from './HSDetails'
import ViewEditHSContextProvider from 'features/MyCommunity/HealthSystems/FullView/Providers/HSContextProvider'
import BankingSetupPopupProvider from 'features/MyCommunity/BankingSetupCommunity/Providers/BankingSetupPopupProvider'

export const HSDetailsContainer = () => {
  return (
    <BankingSetupPopupProvider>
      <ViewEditHSContextProvider>
        <HSDetails />
      </ViewEditHSContextProvider>
    </BankingSetupPopupProvider>
  )
}
